import { api } from './client';
import { ChatListResponse } from '../types/chats';
import { Chat, fromServerChat } from '../utils/chatStorage';

// Signed-in chat history — the server-backed counterpart to chatStorage's
// anonymous localStorage. Full messages come back in one call; there is no
// separate per-chat detail fetch (see routes/chats.py for why).
export async function listMyChats(): Promise<Chat[]> {
  const res = await api.get<ChatListResponse>('/api/chats');
  return res.data.chats.map(fromServerChat);
}
